import { render } from "./Spinner.vue?vue&type=template&id=d5e47396"
import script from "./Spinner.vue?vue&type=script&lang=ts"
export * from "./Spinner.vue?vue&type=script&lang=ts"

import "./Spinner.vue?vue&type=style&index=0&id=d5e47396&lang=postcss"
script.render = render

export default script